
/// Paths & URLs
export const ADMIN_LINK_PATH = "/admin/link";
export const ADMIN_INSULIN_PATH = "/admin/insulin";
export const ADMIN_ALERT_PATH = "/admin/alert/";
export const ADMIN_ALERTS_PATH = "/admin/alert/all";
export const PATIENT_CREATE = "/patient/create";
export const PATIENT_UPDATE = "/patient/update";
export const PATIENT_READ = "/patient/read/";
export const PATIENT_SEARCH = "/patient/search";
export const PATIENT_REVIEW = "/patient/review";
export const PATIENT_REVIEW_CREATE = "/patient/review/create";
export const PATIENT_WEIGHT_CREATE = "/patient/weight/create/";
export const PATIENT_WEIGHT_UPDATE = "/patient/weight/update";
export const PATIENT_WEIGHT_DELETE = "/patient/weight/delete/";
export const PATIENT_MEDICATION_CREATE = "/patient/medication/create";
export const PATIENT_LINK_OBSERVATION = "/patient/link/observation";
export const PATIENT_ARCHIVE = "/patient/archive";
export const PARTICIPANT_PATH = "/participant/";
export const PARTICIPANT_ORPHANS = "/participant/orphan";
export const PARTICIPANT_LINK = "/participant/link";
export const PARTICIPANT_OBSERVATIONS = "/participant/observation/orphan";


export const DASHBOARD_PATH = "/dashboard";

/// Keys
export const REVIEW_KEY = "review";

/// Strings
/// Display Strings
export const APP_TITLE = "MoTHer GDM";

export const USERNAME = "Username";
export const PASSWORD = "Password";

export const ADMINISTRATION = "Clinic Settings";
export const EXIT_ADMINISTRATION = "Exit Clinic Settings";
export const LOG_OUT = "Log Out";

export const ACTIVE_PATIENTS = "Active Patients";
export const ARCHIVED_PATIENTS = "Archived Patients";
export const ARCHIVED_ON = "Archived On";
export const ARCHIVED_REASON = "Reason";
export const CREATE = "Create";
export const NEW_PATIENT = "New Patient";
export const REVIEW_SELECTED_PATIENTS = "Review Selected Patients";
export const COMPLETE_PATIENT_REVIEW = "Complete Review";

export const DEMOGRAPHICS = "Demographics";
export const URN = "URN";
export const DIABETES_TYPE = "Diabetes Type";
export const GESTATION_DIABETES = "Gestation at Diagnosis";
export const GESTATION_DIABETES_WK = "Gestation at Diagnosis (Wk)";
export const CURRENT_GESTATION = "Current Gestation";
export const MANAGEMENT_TYPE = "Management Type";
export const TEAM = "Team";
export const STUDY_ID = "Study Id";
export const RANDOMISED_DATE = "Randomised";
export const RESEARCH = "Research";
export const INSULIN = "Insulin";
export const METFORMIN = "Metformin";
export const DOSE = "dose";
export const DIET = "Diet";
export const INSULIN_METFORMIN = "Insulin and Metformin";
export const INSULIN_TYPE = "Insulin Type";
export const METFORMIN_DOSE = "Metformin Dose (mg)";
export const DUE_DATE = "Estimated Due Date";
export const GESTATION_ENROL_WK = "Gestation at Enrolment (Wk)";
export const WK = "(Wk)";
export const SALUTATION = "Salutation";
export const GIVEN_NAME = "Given Name";
export const FAMILY_NAME = "Family Name";
export const DOB = "Birth Date";
export const BIRTH_PLACE = "Birth Place";
export const GENDER = "Gender";
export const PRE_PREGNANCY_WEIGHT = "Pre-pregnancy Weight (kg)";
export const PRE_PREGNANCY_WEIGHT2 = "Pre-pregnancy Weight";
export const HEIGHT = "Height (cm)";
export const BMI = "BMI";
export const EMAIL = "Email Address";
export const MOBILE_NUMBER = "Mobile Number";
export const INDIGENOUS_STATUS = "Indigenous Status";
export const LANGUAGE = "Preferred Language";
export const DIAGNOSIS_DATE = "Date of Diagnosis";
export const ETHNICITY = "Ethnicity";

export const STATUS = "Status";
export const PATIENT = "Patient";
export const BORN = "Born";
export const KEY_DATES = "Key Dates";
export const DIAGNOSIS = "Diagnosis";
export const PROGRAM = "Program";
export const STARTED = "Started";
export const WEEK = "Week";
export const PROGRESS = "Progress";
export const LINK = "Link";
export const VIEW_LINK = "View Link";
export const EDIT_LINK = "Edit Link";
export const LAST_REVIEW = "Last Review";
export const REVIEW_ALL = "Review All";

export const ADD = "Add";
export const SAVE = "Save";
export const SEND = "Send";
export const CANCEL = "Cancel";
export const CONTINUE = "Continue";
export const COMPLETE_LINK = "Complete Link";
export const COPY = "Copy";
export const UPDATE = "Update";
export const LINK_PARTICIPANT = "Link Registered Participant";
export const LINK_OBSERVATIONS = "Link Observations";
export const LINK_ALL = "Link All";

export const CHOOSE_PATHWAY = "Step 1: Choose Pathway";
export const UNLINKED_PARTICIPANTS = "Step 2: Link Registered Participant";
export const NO_UNLINKED_PARTICIPANTS = "There are no unlinked participants.";
export const ADD_PATIENT_DETAILS_STEP_2 = "Step 2: Add Patient Details";
export const ADD_PATIENT_DETAILS_STEP_4 = "Step 4: Add Patient Details";
export const LINK_PATIENT_MATCH = "Step 3: Link MoTHer Patient";
export const FIND_PATIENT_MATCH = "Find Patient Match";
export const FIND = "Find";
export const SELECT = "Select";
export const UNLINKED_PARTICIPANT = "Unlinked Participants";
export const SELECTED_PARTICIPANT = "Selected Participant";
export const SELECTED_PATIENT = "Selected Patient";
export const NAME = "Name";

export const BGL_SETTINGS = "Bgl Settings";
export const OVERRIDE_DEFAULTS = "Override Defaults";
export const GENERATE_ALERTS = "Generate Alerts";
export const MORNING = "Morning";
export const BREAKFAST = "Breakfast";
export const POST_BREAKFAST = "Post Breakfast";
export const LUNCH = "Lunch";
export const POST_LUNCH = "Post Lunch";
export const DINNER = "Dinner";
export const POST_DINNER = "Post Dinner";
export const BED = "Bed";
export const BEDTIME = "bedtime";
export const PRE_BED = "Pre Bed";
export const START = "Start";
export const END = "End";

export const ALERT = "Alert";
export const SETTINGS = "Settings";
export const MEASUREMENT = "Measurement";
export const CONTEXT = "Atrribute/Context";
export const UNIT = "Unit";
export const UPPER_BOUND = "Upper Bound";
export const LOWER_BOUND = "Lower Bound";
export const SEND_ALERT = "Send Alert";
export const BG = "Blood Glucose";
export const BG_UNIT = "mmol/L";
export const FASTING = "Fasting";
export const AFTER_MEAL = "After Meal";
export const LOW_VALUE = "Low Value";
export const NO_VALUES = "No Data";
export const LOW_VALUE_MSG = "After any reading less than 3.9mmol/L in the last 7 days";
export const OGTT = "Ogtt";
export const OGTT_FASTING = "OGTT Fasting";
export const OGTT_ONE_HOUR = "OGTT One Hour";
export const OGTT_TWO_HOUR = "OGTT Two Hour";
export const BP = "Blood Pressure";
export const SYSTOLIC = "Systolic";
export const DIASTOLIC = "Diastolic";
export const BP_UNIT = "mmHg";
export const ALERT_EVERY = "Every time this occurs";
export const ALERT_3READINGS = "After 3 consecutive readings";
export const ALERT_MISSING = "After 3 consecutive days";
export const ALERT_3IN7 = "After 3 occurrences in 7 days";
export const HIGH = "High";
export const LOW = "Low";
export const SYS = "SYS";
export const DIA = "DIA";
export const PULSE = "PULSE";
export const POST_MEAL = "Post Meal";
export const NO_DATA = "No Data";
export const WEIGHT = "Weight";
export const NEW_WEIGHT = "New Weight";
export const GESTATIONAL_WEIGHT_GAIN_TARGET = "GWG"
export const CLINICIAN = "clinician";
export const MEDICATIONS = "Medications";
export const INSULIN_NAME = "Insulin Name";
export const WHEN_TAKE = "When Take";
export const ADD_MEDICATION = "Add Medication";
export const DOWNLOAD_EMR = "Download EMR Report";

export const WEEKDAYS = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
export const WEEKLY_REVIEW_OFFSET = 6;

export const SEND_MESSAGE = "Send Message";
export const NOTES = "Notes";
export const REVIEW = "Review";
export const HISTORY = "History";
export const DATE = "Date";
export const MESSAGE = "Message";
export const MESSAGE_READ = "Read";
export const YES = "Yes";
export const NO = "No";

export const MOTHER_PATIENT = "MoTHer Patient";
export const POSSIBLE_MATCHES = "Possible Matches";
export const PARTICIPANT_ID = "Participant ID";
export const REGISTEREDON = "Registered On";
export const DOCUMENTID = "Document ID";
export const RESOURCEID = "Resource ID";
export const LASTREVIEWEDDATE = "Last Reviewed Date";
export const PATIENT_ID = "Patient ID";
export const RESOURCE_ID = "Resource ID";
export const PROCEED = "Proceed";

/// Feedback Strings
export const SELECT_ONE = "(select at least one)";
export const PATIENT_FETCH_FAIL = "Failed to fetch patient data!";
export const PATIENT_CREATE_FAIL = "Failed to create new patient!";
export const PATIENT_SAVE_FAIL = "Failed to save new patient!";
export const PARTICIPANT_LINK_FAIL = "Failed to link participant!";
export const WEIGHT_CREATE_FAIL = "Failed to create weight data!"
export const WEIGHT_UPDATE_FAIL = "Failed to update weight data!"
export const WEIGHT_DELETE_FAIL = "Failed to delete weight data!"
export const PRESCRIPTION_FAIL = "Failed to save medications!"
export const DATA_FETCH_FAIL = "Failed to fetch observation data!";
export const DEFAULT_MESSAGE = "Your BGLs are stable. If you have any questions or concerns contact the diabetes nursing team on the details provided. Your data will be reviewed again in 7 days.";
export const NO_MATCH_MESSAGE = " There is no patient match for the selected participant. Do you want to create a new patient?";
export const INSULIN_REQUIRED = "Insulin name is required!";
export const DOSE_REQUIRED = "Insulin dose is required!";

/// Defalut Bgl Setting Value
export const DefaultFastingStart = "05:00";
export const DefaultFastingEnd = "08:59";
export const DefaultBreakfastStart = "09:00";
export const DefaultBreakfastEnd = "12:59";
export const DefaultLunchStart = "13:00";
export const DefaultLunchEnd = "17:59";
export const DefaultDinnerStart = "18:00";
export const DefaultDinnerEnd = "23:59";
export const DefaultOvernightStart = "00:00";
export const DefaultOvernightEnd = "04:59";


// Types of insulin && Contexts
export const Medications = ["Novorapid", "Protaphane", "Degludec", "Humalog", "Levemir", "Optisulin", "Metformin"];
export const INSULIN_DOSE = "Insulin Dose (units)";
export const OVERNIGHT = "Overnight";

/// Default Review History Values
export const DefaultNoSMS = "Message not recorded";
export const DefaultNoNotes = "Notes not recorded";

// Spinner words
export const LoadingPatient = "Loading Patients...";
export const SavingPatient = "Saving Patient...";

export const AlertSettingsTitle = "Alert Settings";
export const EducationLinksTitle = "Education Links";
export const InsulinTypesTitle = "Insulin Types";
export const DisplayAs = "Display As";
export const Url = "URL";
export const Default = "Default";

// Warning message
export const WARNING = "The matching process has detected insufficient matches. Are your sure you want to proceed?";